import React, { ReactNode, useReducer, useRef } from "react";

const AuthorizationContext = React.createContext<any>({
  isAllowedByActions: () => true,
  isAllowed: () => true,
  setPermision: () => {},
  entities: {},
});
export const useAuthorization = () => {
  const context = React.useContext(AuthorizationContext);
  return context;
};
export const AuthorizationProvider = (props: any) => {
  const permissionsRef = useRef([]);
  const entitiesRef = useRef({});

  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const isAllowed = (endpoints: any) => {
    endpoints = Array.isArray(endpoints) ? endpoints : [endpoints];
    return endpoints
      .map((endpoint: any) => {
        const permissions = permissionsRef.current;
        return permissions.some(
          (permision: any) =>
            permision.path === endpoint.path &&
            permision.method === endpoint.method
        );
      })
      .some((allowed: any) => allowed);
  };

  const isAllowedByActions = (actions: any) => {
    actions = Array.isArray(actions) ? actions : [actions];
    return actions.some((a: any) => {
      const parts = a.split(".");
      const resource = parts[0];
      const key = parts[1];
      return !!entitiesRef.current[resource]?.[key];
    });
  };

  return (
    <AuthorizationContext.Provider
      value={{
        isAllowedByActions,
        isAllowed,
        entities: entitiesRef.current,
        setPermision: (permissions) => {
          permissionsRef.current = permissions;
          entitiesRef.current = permissions.reduce((t, e) => {
            const { entity, key_name } = e;
            const action = key_name.toLowerCase().replace(/\s/g, "_");
            const resouce = t[entity];
            if (!resouce) {
              t[entity] = {};
            }
            t[entity][action] = {
              ...e,
              name: undefined,
              id: undefined,
              entity: undefined,
              key_name: undefined,
            };
            return t;
          }, {});
          forceUpdate();
        },
      }}
    >
      {props.children}
    </AuthorizationContext.Provider>
  );
};
interface IAuthorization {
  actions?: string[] | string;
  children: ReactNode;
  endpoints?: string[] | string;
}
export const Authorization = (props: IAuthorization) => {
  const { endpoints, actions } = props;
  const authorization = useAuthorization();
  const isAuthorized = endpoints
    ? authorization.isAllowed(endpoints)
    : actions
    ? authorization.isAllowedByActions(actions)
    : false;

  return <> {isAuthorized && props.children}</>;
};
